import './ProductInfo.scss';

import { createClsNameMap, getAppConfig, objectKeys } from '@utils';
import { Fragment } from 'react';

import type { CTAButtonProps } from '@/features/filter-product-list/product-list/product-item/CallToActionButton';
import IntegrationProductLabel from '@/features/filter-product-list/product-list/product-item/IntegrationProductLabel';
import IntegrationProductQuickView from '@/features/filter-product-list/product-list/product-item/IntegrationProductQuickView';
import type { IntegrationProductRatingProps } from '@/features/filter-product-list/product-list/product-item/IntegrationProductRating';
import IntegrationProductReviewFera from '@/features/filter-product-list/product-list/product-item/IntegrationProductReviewFera';
import IntegrationProductWishlist from '@/features/filter-product-list/product-list/product-item/IntegrationProductWishlist';
import type { InventoryStatusProps } from '@/features/filter-product-list/product-list/product-item/InventoryStatus';
import type { ProductSwatchProps } from '@/features/filter-product-list/product-list/product-item/ProductSwatch';

import type { ProductDescriptionProps } from '../ProductDescription';
import type { ProductPriceProps } from '../ProductPrice';
import type { ProductTitleProps } from '../ProductTitle';
import type { ProductVendorProps } from '../ProductVendor';

const clsNameMap = createClsNameMap()('product-info');

export type ProductInfoElement =
  | 'title'
  | 'vendor'
  | 'desc'
  | 'price'
  | 'inventoryStatus'
  | `swatches.${number}`
  | 'qvBtn'
  | 'selectOptionBtn'
  | 'goToDetailBtn'
  // 3rd App Integration
  | 'rating';

export type ProductInfoProps = {
  elements?: {
    title?: React.ReactElement<ProductTitleProps>;
    vendor?: React.ReactElement<ProductVendorProps>;
    desc?: React.ReactElement<ProductDescriptionProps>;
    price?: React.ReactElement<ProductPriceProps>;
    inventoryStatus?: React.ReactElement<InventoryStatusProps>;
    [swatches: `swatches.${number}`]: React.ReactElement<ProductSwatchProps> | undefined;
    qvBtn?: React.ReactElement<CTAButtonProps>;
    selectOptionBtn?: React.ReactElement<CTAButtonProps>;
    goToDetailBtn?: React.ReactElement<CTAButtonProps>;
    // Integration 3rd App
    rating?: React.ReactElement<IntegrationProductRatingProps>;
  };
  disabledElements?: Partial<Record<ProductInfoElement, boolean>>;
  orders?: ProductInfoElement[];
  padding?: React.CSSProperties['padding'];
  textAlign?: React.CSSProperties['textAlign'];
};

const ProductInfo = ({
  elements,
  orders,
  disabledElements,
  padding,
  textAlign,
}: ProductInfoProps) => {
  const renderElements = () => {
    if (!elements) return null;
    return (orders || objectKeys(elements)).map((elementType) => {
      if (disabledElements?.[elementType]) return null;

      return <Fragment key={elementType}>{elements[elementType]}</Fragment>;
    });
  };
  const style: React.CSSProperties = {
    padding,
    textAlign,
  };

  const integration = getAppConfig()?.integration;

  return (
    <div className={clsNameMap.root()} style={style}>
      <>
        {integration?.others === 'secomapp' && <IntegrationProductQuickView />}
        {renderElements()}
        {integration?.wishlists && <IntegrationProductWishlist />}
        {integration?.labels && <IntegrationProductLabel />}
        {integration?.others === 'fera' && <IntegrationProductReviewFera />}
      </>
    </div>
  );
};
export default ProductInfo;
